import React, { useMemo } from 'react';

import { Grid } from '../../layout/Grid/Grid';
import { GridRow } from '../../layout/Grid/GridRow';
import { GridColumn } from '../../layout/Grid/GridColumn';
import { CondensedSmall } from '../../content/CondensedSmall/CondensedSmall';
import { Gutter } from '../../layout/Gutter/Gutter';
import { useBreakpoint } from '../../../hooks/useBreakpoint';

import type { ProgressGroupContextType } from './ProgressGroupContext';
import { ProgressGroupContext } from './ProgressGroupContext';

export type ProgressGroupProps = {
  name?: string;
  children: React.ReactNode;
  minimal?: ProgressGroupContextType['minimal'];
  graduationCount?: ProgressGroupContextType['graduations'];
  stacked?: boolean;
};

export const ProgressGroup = ({
  name,
  children,
  graduationCount = 1,
  minimal = false,
  stacked = false,
}: ProgressGroupProps) => {
  const { isTablet } = useBreakpoint();
  const contextMemo: ProgressGroupContextType = useMemo(
    () => ({
      showLabel: false,
      stacked,
      graduations: minimal ? 0 : graduationCount,
      minimal,
    }),
    [graduationCount, minimal]
  );

  return (
    <ProgressGroupContext.Provider value={contextMemo}>
      <Grid
        name={name || 'PROGRESS_GROUP_CONTAINER'}
        stackable
        className="progress-group"
      >
        {children}
        {!minimal && (
          <GridRow name="MEETS_EXPECTATIONS_CONTAINER">
            <GridColumn
              name="MEETS_EXPECTATION_COL"
              width={stacked || isTablet ? 8 : 6}
              textAlign="center"
            >
              <Gutter top="8px" only="largeScreen" />
              <CondensedSmall>
                <div className="small-up-carrot" />
                <Gutter bottom="4px" />
                Meets Expectations
              </CondensedSmall>
            </GridColumn>
          </GridRow>
        )}
      </Grid>
    </ProgressGroupContext.Provider>
  );
};
